import React from 'react';
import DateLabel from '../../../../general/date/date-label';
import ReadOnlyWrapper from '../../../read-only';
import TimeLabel from './controls/time-label';

interface IProps {
  date?: string;
  time?: string;
}

class ReadOnly extends React.PureComponent<IProps> {
  render() {
    const { date, time } = this.props;

    return (
      <React.Fragment>
        <ReadOnlyWrapper
          forceNotSpecified={!date}
          isDate={true}
          value={<DateLabel value={date} skipUtc={true} />}
        />
        <ReadOnlyWrapper
          forceNotSpecified={!time}
          isDate={true}
          value={<TimeLabel value={time} skipUtc={true} />}
        />
      </React.Fragment>
    );
  }
}

export default ReadOnly;
